/** 推理镜像附加存储卷（只读回显） */
export const MAAS_IMAGE_STORAGE_FIELD_KEYS = {
  imageStorageVolumes: 'mi.imageStorageVolumes',
} as const;

export const MAAS_IMAGE_STORAGE_FIELD_KEY_LIST = [MAAS_IMAGE_STORAGE_FIELD_KEYS.imageStorageVolumes] as const;
